import { defineStore } from "pinia";
import apiService from "@/services/ApiService";
import {
  ILoginPostData,
  ILoginResponse,
  IRequestOtpResponse,
  IUser,
} from "@/modules/Auth/types";
import { JwtService } from "@/services/JwtService";

export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: {} as IUser,
    requestOtpResponse: {} as IRequestOtpResponse,
    profileLoading: true,
    blockedTime: 0,
  }),
  actions: {
    login(params: ILoginPostData) {
      return new Promise((resolve, reject) => {
        apiService
          .post<ILoginPostData, ILoginResponse>("user/auth/login/", {
            email: params.email?.toLowerCase(),
            password: params.password,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    verifyOtp(otp: string, email: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/auth/verify/", {
            email: email,
            otp_code: otp,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    verifyOtpRecovery(email: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/recovery/email/", {
            email: email,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    verifyOtpUserChange(email: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/change/email/", {
            email: email,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    verifyResetOtp(otp: string, email: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/recovery/verify/", {
            email: email,
            otp_code: otp,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    userChangeEmailVerify(otp: string, email: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/change/verify/", {
            email: email,
            otp_code: otp,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    userEmailVerify(token: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/auth/verify/", {
            token,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    userCheckEmail(email: string, phone_number: string) {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/auth/check-email-phone/", {
            email,
            phone_number,
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    userSendEmailVerification() {
      return new Promise((resolve, reject) => {
        apiService
          .post("user/auth/send-email-verification-link/")
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchUserData() {
      apiService.setHeader();
      this.profileLoading = true;
      return new Promise((resolve, reject) => {
        apiService
          .get<IUser>("user/profile/")
          .then((res) => {
            this.user = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            setTimeout(() => {
              this.profileLoading = false;
            }, 500);
          });
      });
    },
    logout() {
      JwtService.destroyAccess();
      JwtService.destroyRefresh();
      apiService.setHeader();
      this.user = {} as IUser;
    },
  },
});
